import { actionCreators } from './actions';

export const overrideNavigation = (parameters) => {
  window.top.store.dispatch(actionCreators.override(parameters));
};

export const releaseNavigationOverride = () => {
  window.top.store.dispatch(actionCreators.release());
};
